import { render } from "./projectLayer.vue?vue&type=template&id=541b0927"
import script from "./projectLayer.vue?vue&type=script&lang=js"
export * from "./projectLayer.vue?vue&type=script&lang=js"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__